import { currencyFormatter } from '@/helpers/currencyFormatter';
import { percentageFormatter } from '@/helpers/percentageFormatter';
import { Badge, Icon } from '@palmetto/palmetto-components';
import { Link } from 'react-router-dom';

import { PriceSheetStatus, ProgramType } from 'types';

import DateTimeDisplay from '../../DateTime';

export const priceSheetColumns = {
  [ProgramType.solar]: [
    {
      heading: 'Status',
      dataKey: 'status',
      width: 125,
      render: (_cell: any, row: any) => (
        <Badge
          variant={
            row.status === PriceSheetStatus.active
              ? 'success'
              : row.status === PriceSheetStatus.archived
                ? 'warning'
                : 'danger'
          }
          message={row.status}
        />
      ),
    },
    {
      heading: 'Name',
      dataKey: 'name',
      render: (_cell: any, row: any) => (
        <Link
          style={{ color: 'var(--color-text-body-primary)' }}
          className="font-size-md font-weight-bold"
          to={`/admin/pricing/${row.programType}/price-sheet/${row.id}`}
        >
          {row.name}
        </Link>
      ),
    },
    {
      heading: 'KWH Rate Floor',
      dataKey: 'kwhRateFloor',
      headerClassName: 'wrap',
    },
    {
      heading: 'KWH Rate Ceiling',
      dataKey: 'kwhRateCeiling',
      headerClassName: 'wrap',
    },
    {
      heading: 'Production Factor Floor',
      dataKey: 'productionFactorFloor',
      headerClassName: 'wrap',
    },
    {
      heading: 'Production Factor Ceiling',
      dataKey: 'productionFactorCeiling',
      headerClassName: 'wrap',
    },
    {
      heading: 'Created',
      dataKey: 'createdDate',
      width: 150,
      render: (_cell: any, row: Record<'createdDate', string>) => (
        <DateTimeDisplay value={row?.createdDate} dateFormat={'DD'} excludeTime />
      ),
    },
    {
      heading: 'Archived',
      dataKey: 'archivedDate',
      width: 150,
      render: (_cell: any, row: Record<'archivedDate', string>) => (
        <DateTimeDisplay value={row?.archivedDate} dateFormat={'DD'} excludeTime />
      ),
    },
    {
      render: (_cell: any, row: any) =>
        row.status !== 'archived' && (
          <Link
            to={`/admin/pricing/${row.programType}/price-sheet/edit/${row.id}`}
            style={{ textDecoration: 'underline' }}
          >
            <Icon color="body-primary" name="settings" size="sm" />
          </Link>
        ),
    },
  ],
  [ProgramType.newHomes]: [
    {
      heading: 'Status',
      dataKey: 'status',
      width: 125,
      render: (_cell: any, row: any) => (
        <Badge
          variant={
            row.status === PriceSheetStatus.active
              ? 'success'
              : row.status === PriceSheetStatus.archived
                ? 'warning'
                : 'danger'
          }
          message={row.status}
        />
      ),
    },
    {
      heading: 'Name',
      dataKey: 'name',
      render: (_cell: any, row: any) => (
        <Link
          style={{ color: 'var(--color-text-body-primary)' }}
          className="font-size-md font-weight-bold"
          to={`/admin/pricing/${row.programType}/price-sheet/${row.id}`}
        >
          {row.name}
        </Link>
      ),
    },
    {
      heading: 'KWH Rate Floor',
      dataKey: 'kwhRateFloor',
      headerClassName: 'wrap',
    },
    {
      heading: 'KWH Rate Ceiling',
      dataKey: 'kwhRateCeiling',
      headerClassName: 'wrap',
    },
    {
      heading: 'Production Factor Floor',
      dataKey: 'productionFactorFloor',
      headerClassName: 'wrap',
    },
    {
      heading: 'Production Factor Ceiling',
      dataKey: 'productionFactorCeiling',
      headerClassName: 'wrap',
    },
    {
      heading: 'Created',
      dataKey: 'createdDate',
      width: 150,
      render: (_cell: any, row: Record<'createdDate', string>) => (
        <DateTimeDisplay value={row?.createdDate} dateFormat={'DD'} excludeTime />
      ),
    },
    {
      heading: 'Archived',
      dataKey: 'archivedDate',
      width: 150,
      render: (_cell: any, row: Record<'archivedDate', string>) => (
        <DateTimeDisplay value={row?.archivedDate} dateFormat={'DD'} excludeTime />
      ),
    },
    {
      render: (_cell: any, row: any) =>
        row.status !== 'archived' && (
          <Link
            to={`/admin/pricing/${row.programType}/price-sheet/edit/${row.id}`}
            style={{ textDecoration: 'underline' }}
          >
            <Icon color="body-primary" name="settings" size="sm" />
          </Link>
        ),
    },
  ],
  [ProgramType.hvac]: [
    {
      heading: 'Status',
      dataKey: 'status',
      width: 125,
      render: (_cell: any, row: any) => (
        <Badge
          variant={
            row.status === PriceSheetStatus.active
              ? 'success'
              : row.status === PriceSheetStatus.archived
                ? 'warning'
                : 'danger'
          }
          message={row.status}
        />
      ),
    },
    {
      heading: 'Name',
      dataKey: 'name',
      render: (_cell: any, row: any) => (
        <Link
          style={{ color: 'var(--color-text-body-primary)' }}
          className="font-size-md font-weight-bold"
          to={`/admin/pricing/${row.programType}/price-sheet/${row.id}`}
        >
          {row.name}
        </Link>
      ),
    },
    {
      heading: 'Created',
      dataKey: 'createdDate',
      width: 150,
      render: (_cell: any, row: Record<'createdDate', string>) => (
        <DateTimeDisplay value={row?.createdDate} dateFormat={'DD'} excludeTime />
      ),
    },
    {
      heading: 'Archived',
      dataKey: 'archivedDate',
      width: 150,
      render: (_cell: any, row: Record<'archivedDate', string>) => (
        <DateTimeDisplay value={row?.archivedDate} dateFormat={'DD'} excludeTime />
      ),
    },
    {
      render: (_cell: any, row: any) =>
        row.status !== 'archived' && (
          <Link
            to={`/admin/pricing/${row.programType}/price-sheet/edit/${row.id}`}
            style={{ textDecoration: 'underline' }}
          >
            <Icon color="body-primary" name="settings" size="sm" />
          </Link>
        ),
    },
  ],
  [ProgramType.waterHeater]: [
    {
      heading: 'Status',
      dataKey: 'status',
      width: 125,
      render: (_cell: any, row: any) => (
        <Badge
          variant={
            row.status === PriceSheetStatus.active
              ? 'success'
              : row.status === PriceSheetStatus.archived
                ? 'warning'
                : 'danger'
          }
          message={row.status}
        />
      ),
    },
    {
      heading: 'Name',
      dataKey: 'name',
      render: (_cell: any, row: any) => (
        <Link
          style={{ color: 'var(--color-text-body-primary)' }}
          className="font-size-md font-weight-bold"
          to={`/admin/pricing/${row.programType}/price-sheet/${row.id}`}
        >
          {row.name}
        </Link>
      ),
    },
    {
      heading: 'Created',
      dataKey: 'createdDate',
      width: 150,
      render: (_cell: any, row: Record<'createdDate', string>) => (
        <DateTimeDisplay value={row?.createdDate} dateFormat={'DD'} excludeTime />
      ),
    },
    {
      heading: 'Archived',
      dataKey: 'archivedDate',
      width: 150,
      render: (_cell: any, row: Record<'archivedDate', string>) => (
        <DateTimeDisplay value={row?.archivedDate} dateFormat={'DD'} excludeTime />
      ),
    },
    {
      render: (_cell: any, row: any) =>
        row.status !== 'archived' && (
          <Link
            to={`/admin/pricing/${row.programType}/price-sheet/edit/${row.id}`}
            style={{ textDecoration: 'underline' }}
          >
            <Icon color="body-primary" name="settings" size="sm" />
          </Link>
        ),
    },
  ],
  [ProgramType.generator]: [
    {
      heading: 'Status',
      dataKey: 'status',
      width: 125,
      render: (_cell: any, row: any) => (
        <Badge
          variant={
            row.status === PriceSheetStatus.active
              ? 'success'
              : row.status === PriceSheetStatus.archived
                ? 'warning'
                : 'danger'
          }
          message={row.status}
        />
      ),
    },
    {
      heading: 'Name',
      dataKey: 'name',
      render: (_cell: any, row: any) => (
        <Link
          style={{ color: 'var(--color-text-body-primary)' }}
          className="font-size-md font-weight-bold"
          to={`/admin/pricing/${row.programType}/price-sheet/${row.id}`}
        >
          {row.name}
        </Link>
      ),
    },
    {
      heading: 'Created',
      dataKey: 'createdDate',
      width: 150,
      render: (_cell: any, row: Record<'createdDate', string>) => (
        <DateTimeDisplay value={row?.createdDate} dateFormat={'DD'} excludeTime />
      ),
    },
    {
      heading: 'Archived',
      dataKey: 'archivedDate',
      width: 150,
      render: (_cell: any, row: Record<'archivedDate', string>) => (
        <DateTimeDisplay value={row?.archivedDate} dateFormat={'DD'} excludeTime />
      ),
    },
    {
      render: (_cell: any, row: any) =>
        row.status !== 'archived' && (
          <Link
            to={`/admin/pricing/${row.programType}/price-sheet/edit/${row.id}`}
            style={{ textDecoration: 'underline' }}
          >
            <Icon color="body-primary" name="settings" size="sm" />
          </Link>
        ),
    },
  ],
  [ProgramType.doePr]: [
    {
      heading: 'Status',
      dataKey: 'status',
      width: 125,
      render: (_cell: any, row: any) => (
        <Badge
          variant={
            row.status === PriceSheetStatus.active
              ? 'success'
              : row.status === PriceSheetStatus.archived
                ? 'warning'
                : 'danger'
          }
          message={row.status}
        />
      ),
    },
    {
      heading: 'Name',
      dataKey: 'name',
      render: (_cell: any, row: any) => (
        <Link
          style={{ color: 'var(--color-text-body-primary)' }}
          className="font-size-md font-weight-bold"
          to={`/admin/pricing/${row.programType}/price-sheet/${row.id}`}
        >
          {row.name}
        </Link>
      ),
    },
    {
      heading: 'Min Battery Capacity',
      dataKey: 'minBatteryCapacity',
      headerClassName: 'wrap',
    },
    {
      heading: 'Max Battery Capacity',
      dataKey: 'maxBatteryCapacity',
      headerClassName: 'wrap',
    },
    {
      heading: 'Min System Size',
      dataKey: 'minSystemSize',
      headerClassName: 'wrap',
    },
    {
      heading: 'Max System Size',
      dataKey: 'maxSystemSize',
      headerClassName: 'wrap',
    },
    {
      heading: 'Created',
      dataKey: 'createdDate',
      width: 150,
      render: (_cell: any, row: Record<'createdDate', string>) => (
        <DateTimeDisplay value={row?.createdDate} dateFormat={'DD'} excludeTime />
      ),
    },
    {
      heading: 'Archived',
      dataKey: 'archivedDate',
      width: 150,
      render: (_cell: any, row: Record<'archivedDate', string>) => (
        <DateTimeDisplay value={row?.archivedDate} dateFormat={'DD'} excludeTime />
      ),
    },
    {
      render: (_cell: any, row: any) =>
        row.status !== 'archived' && (
          <Link
            to={`/admin/pricing/${row.programType}/price-sheet/edit/${row.id}`}
            style={{ textDecoration: 'underline' }}
          >
            <Icon color="body-primary" name="settings" size="sm" />
          </Link>
        ),
    },
  ],
  [ProgramType.energyBackup]: [
    {
      heading: 'Status',
      dataKey: 'status',
      width: 125,
      render: (_cell: any, row: any) => (
        <Badge
          variant={
            row.status === PriceSheetStatus.active
              ? 'success'
              : row.status === PriceSheetStatus.archived
                ? 'warning'
                : 'danger'
          }
          message={row.status}
        />
      ),
    },
    {
      heading: 'Name',
      dataKey: 'name',
      render: (_cell: any, row: any) => (
        <Link
          style={{ color: 'var(--color-text-body-primary)' }}
          className="font-size-md font-weight-bold"
          to={`/admin/pricing/${row.programType}/price-sheet/${row.id}`}
        >
          {row.name}
        </Link>
      ),
    },
    {
      heading: 'Created',
      dataKey: 'createdDate',
      width: 150,
      render: (_cell: any, row: Record<'createdDate', string>) => (
        <DateTimeDisplay value={row?.createdDate} dateFormat={'DD'} excludeTime />
      ),
    },
    {
      heading: 'Archived',
      dataKey: 'archivedDate',
      width: 150,
      render: (_cell: any, row: Record<'archivedDate', string>) => (
        <DateTimeDisplay value={row?.archivedDate} dateFormat={'DD'} excludeTime />
      ),
    },
    {
      render: (_cell: any, row: any) =>
        row.status !== 'archived' && (
          <Link
            to={`/admin/pricing/${row.programType}/price-sheet/edit/${row.id}`}
            style={{ textDecoration: 'underline' }}
          >
            <Icon color="body-primary" name="settings" size="sm" />
          </Link>
        ),
    },
  ],
  [ProgramType.geothermal]: [
    {
      heading: 'Status',
      dataKey: 'status',
      width: 125,
      render: (_cell: any, row: any) => (
        <Badge
          variant={
            row.status === PriceSheetStatus.active
              ? 'success'
              : row.status === PriceSheetStatus.archived
                ? 'warning'
                : 'danger'
          }
          message={row.status}
        />
      ),
    },
    {
      heading: 'Name',
      dataKey: 'name',
      render: (_cell: any, row: any) => (
        <Link
          style={{ color: 'var(--color-text-body-primary)' }}
          className="font-size-md font-weight-bold"
          to={`/admin/pricing/${row.programType}/price-sheet/${row.id}`}
        >
          {row.name}
        </Link>
      ),
    },
    {
      heading: 'Created',
      dataKey: 'createdDate',
      width: 150,
      render: (_cell: any, row: Record<'createdDate', string>) => (
        <DateTimeDisplay value={row?.createdDate} dateFormat={'DD'} excludeTime />
      ),
    },
    {
      heading: 'Archived',
      dataKey: 'archivedDate',
      width: 150,
      render: (_cell: any, row: Record<'archivedDate', string>) => (
        <DateTimeDisplay value={row?.archivedDate} dateFormat={'DD'} excludeTime />
      ),
    },
    {
      render: (_cell: any, row: any) =>
        row.status !== 'archived' && (
          <Link
            to={`/admin/pricing/${row.programType}/price-sheet/edit/${row.id}`}
            style={{ textDecoration: 'underline' }}
          >
            <Icon color="body-primary" name="settings" size="sm" />
          </Link>
        ),
    },
  ],
  [ProgramType.newCommunity]: [],
  [ProgramType.consumerSolar]: [
    {
      heading: 'Status',
      dataKey: 'status',
      width: 125,
      render: (_cell: any, row: any) => (
        <Badge
          variant={
            row.status === PriceSheetStatus.active
              ? 'success'
              : row.status === PriceSheetStatus.archived
                ? 'warning'
                : 'danger'
          }
          message={row.status}
        />
      ),
    },
    {
      heading: 'Name',
      dataKey: 'name',
      render: (_cell: any, row: any) => (
        <Link
          style={{ color: 'var(--color-text-body-primary)' }}
          className="font-size-md font-weight-bold"
          to={`/admin/pricing/${row.programType}/price-sheet/${row.id}`}
        >
          {row.name}
        </Link>
      ),
    },
    {
      heading: 'Min System Size',
      dataKey: 'minSystemSize',
      headerClassName: 'wrap',
    },
    {
      heading: 'Max System Size',
      dataKey: 'maxSystemSize',
      headerClassName: 'wrap',
    },
    {
      heading: 'Min Production Factor',
      dataKey: 'minProductionFactor',
      headerClassName: 'wrap',
    },
    {
      heading: 'Max Production Factor',
      dataKey: 'maxProductionFactor',
      headerClassName: 'wrap',
    },
    {
      heading: 'Created',
      dataKey: 'createdDate',
      width: 150,
      render: (_cell: any, row: Record<'createdDate', string>) => (
        <DateTimeDisplay value={row?.createdDate} dateFormat={'DD'} excludeTime />
      ),
    },
    {
      heading: 'Archived',
      dataKey: 'archivedDate',
      width: 150,
      render: (_cell: any, row: Record<'archivedDate', string>) => (
        <DateTimeDisplay value={row?.archivedDate} dateFormat={'DD'} excludeTime />
      ),
    },
    {
      render: (_cell: any, row: any) =>
        row.status !== 'archived' && (
          <Link
            to={`/admin/pricing/${row.programType}/price-sheet/edit/${row.id}`}
            style={{ textDecoration: 'underline' }}
          >
            <Icon color="body-primary" name="settings" size="sm" />
          </Link>
        ),
    },
  ],
};

export const priceSheetDetailColumns = {
  [ProgramType.solar]: [],
  [ProgramType.newCommunity]: [],
  [ProgramType.newHomes]: [],
  [ProgramType.consumerSolar]: [
    {
      heading: 'Escalation Rate',
      dataKey: 'escalationRate',
      headerClassName: 'wrap',
      render: (cell: any) => {
        return <div>{percentageFormatter.format(cell)}</div>;
      },
    },
    {
      heading: 'Min System Size (kW)',
      dataKey: 'minSystemSize',
      headerClassName: 'wrap',
    },
    {
      heading: 'Max System Size (kW)',
      dataKey: 'maxSystemSize',
      headerClassName: 'wrap',
    },
    {
      heading: 'Min Production Factor (kWh/kW)',
      dataKey: 'minProductionFactor',
      headerClassName: 'wrap',
    },
    {
      heading: 'Max Production Factor (kWh/kW)',
      dataKey: 'maxProductionFactor',
      headerClassName: 'wrap',
    },
    {
      heading: 'KWH Rate',
      dataKey: 'kwhRate',
      headerClassName: 'wrap',
      render: (cell: any) => {
        return <div>{currencyFormatter.format(cell)}</div>;
      },
    },
    {
      heading: 'PPW',
      dataKey: 'ppwRate',
      headerClassName: 'wrap',
      render: (cell: any) => {
        return <div>{currencyFormatter.format(cell)}</div>;
      },
    },
  ],
  [ProgramType.hvac]: [
    {
      heading: 'Escalation Rate',
      dataKey: 'escalationRate',
      headerClassName: 'wrap',
      render: (cell: any) => {
        return <div>{percentageFormatter.format(cell)}</div>;
      },
    },
    { heading: 'Term', dataKey: 'term', headerClassName: 'wrap' },
    { heading: 'Min System Cost', dataKey: 'minSystemCost', headerClassName: 'wrap' },
    { heading: 'Max System Cost', dataKey: 'maxSystemCost', headerClassName: 'wrap' },
    { heading: 'Payment Factor', dataKey: 'paymentFactor', headerClassName: 'wrap' },
  ],
  [ProgramType.waterHeater]: [
    {
      heading: 'Escalation Rate',
      dataKey: 'escalationRate',
      headerClassName: 'wrap',
      render: (cell: any) => {
        return <div>{percentageFormatter.format(cell)}</div>;
      },
    },
    { heading: 'Term', dataKey: 'term', headerClassName: 'wrap' },
    { heading: 'Min System Cost', dataKey: 'minSystemCost', headerClassName: 'wrap' },
    { heading: 'Max System Cost', dataKey: 'maxSystemCost', headerClassName: 'wrap' },
    { heading: 'Payment Factor', dataKey: 'paymentFactor', headerClassName: 'wrap' },
  ],
  [ProgramType.generator]: [
    {
      heading: 'Escalation Rate',
      dataKey: 'escalationRate',
      headerClassName: 'wrap',
      render: (cell: any) => {
        return <div>{percentageFormatter.format(cell)}</div>;
      },
    },
    { heading: 'Term', dataKey: 'term', headerClassName: 'wrap' },
    { heading: 'Min System Cost', dataKey: 'minSystemCost', headerClassName: 'wrap' },
    { heading: 'Max System Cost', dataKey: 'maxSystemCost', headerClassName: 'wrap' },
    { heading: 'Payment Factor', dataKey: 'paymentFactor', headerClassName: 'wrap' },
  ],
  [ProgramType.geothermal]: [
    {
      heading: 'Escalation Rate',
      dataKey: 'escalationRate',
      headerClassName: 'wrap',
      render: (cell: any) => {
        return <div>{percentageFormatter.format(cell)}</div>;
      },
    },
    { heading: 'Term', dataKey: 'term', headerClassName: 'wrap' },
    { heading: 'Min System Cost', dataKey: 'minSystemCost', headerClassName: 'wrap' },
    { heading: 'Max System Cost', dataKey: 'maxSystemCost', headerClassName: 'wrap' },
    { heading: 'Payment Factor', dataKey: 'paymentFactor', headerClassName: 'wrap' },
  ],
  [ProgramType.energyBackup]: [
    {
      heading: 'Escalation Rate',
      dataKey: 'escalationRate',
      headerClassName: 'wrap',
      render: (cell: any) => {
        return <div>{percentageFormatter.format(cell)}</div>;
      },
    },
    { heading: 'Term', dataKey: 'term', headerClassName: 'wrap' },
    { heading: 'Min System Cost', dataKey: 'minSystemCost', headerClassName: 'wrap' },
    { heading: 'Max System Cost', dataKey: 'maxSystemCost', headerClassName: 'wrap' },
    { heading: 'Payment Factor', dataKey: 'paymentFactor', headerClassName: 'wrap' },
  ],
  [ProgramType.doePr]: [
    {
      heading: 'Escalation Rate',
      dataKey: 'escalationRate',
      headerClassName: 'wrap',
      render: (cell: any) => {
        return <div>{percentageFormatter.format(cell)}</div>;
      },
    },
    {
      heading: 'Min System Size (kW)',
      dataKey: 'minSystemSize',
      headerClassName: 'wrap',
    },
    {
      heading: 'Max System Size (kW)',
      dataKey: 'maxSystemSize',
      headerClassName: 'wrap',
    },
    {
      heading: 'Min Battery Capacity (kW)',
      dataKey: 'minBatteryCapacity',
      headerClassName: 'wrap',
    },
    {
      heading: 'Max Battery Capacity (kW)',
      dataKey: 'maxBatteryCapacity',
      headerClassName: 'wrap',
    },
    {
      heading: 'Monthly Payment',
      dataKey: 'monthlyPayment',
      headerClassName: 'wrap',
      render: (cell: any) => {
        return <div>{currencyFormatter.format(cell)}</div>;
      },
    },
    {
      heading: 'PPW',
      dataKey: 'ppwRate',
      headerClassName: 'wrap',
      render: (cell: any) => {
        return <div>{currencyFormatter.format(cell)}</div>;
      },
    },
  ],
};
